"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearch = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../hooks");

var utility_1 = require("../utility");

var useSearch = function useSearch() {
  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options,
      config = _ref.config,
      search = _ref.search;

  var handleSubmitSearchTerm = react_1.default.useCallback(function () {
    var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search.searchTerm;
    utility_1.debug.log("useSearch", "submitSearchTerm[query]", searchTerm);

    if (!searchTerm) {
      return;
    }

    var redirect = config.redirects.find(function (redirect) {
      return redirect.query.trim().toLowerCase() === searchTerm.trim().toLowerCase();
    });

    if (redirect) {
      utility_1.debug.log("useSearch", "submitSearchTerm[redirect]", redirect);
    }

    search.setShowInstantSearchResults(false);

    if (options.onRedirect) {
      options.onRedirect(redirect ? "redirect" : "search", redirect ? redirect.url : "/search?q=".concat(encodeURIComponent(searchTerm)));
    } else if (redirect) {
      window.location.href = redirect.url;
    } else {
      window.location.href = "/search?q=".concat(encodeURIComponent(searchTerm));
    }
  }, [search.searchTerm]);
  var handleSetSearchTerm = react_1.default.useCallback(function () {
    var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    utility_1.debug.log("useSearch", "setSearchTerm[searchTerm]", searchTerm);
    search.setSearchTerm(searchTerm);
  }, [search.searchTerm]);
  return {
    searchTerm: search.searchTerm,
    setSearchTerm: handleSetSearchTerm,
    submitSearchTerm: handleSubmitSearchTerm,
    showInstantSearchResults: !!search.showInstantSearchResults && !!search.searchTerm,
    setShowInstantSearchResults: search.setShowInstantSearchResults
  };
};

exports.useSearch = useSearch;